// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import VueCordova from 'vue-cordova'
import VueHead from 'vue-head'
import App from './App'
import router from './router'
import { store } from './store/store.js'
import VueFire from 'vuefire'
import { auth, db } from './firebase/index.js'
import Vuelidate from 'vuelidate'

Vue.use(Vuetify, {
  theme: {
    primary: '#3C5473',
    secondary: '#668099',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
}
)
Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(VueCordova)
Vue.use(VueHead)
Vue.use(VueFire)
Vue.filter('percent', function(value){
  if (!value) return
  return value.toString() + '%'
})

// add cordova.js only if serving the app through file://
if (window.location.protocol === 'file:' || window.location.port === '3000') {
  var cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
}
/* eslint-disable no-new */

let app = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  head: {
    meta: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
      }
    ]
  },
})

Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});


